<template>
  <div class="filter">
    <div class="filter__title-wrap">
      <ys-text type="title4" class="filter__title content-item">
        Boat Launch
      </ys-text>
      <ys-icon
        v-if="!hasFilterAccess"
        icon="ysLock"
        data-test="lock"
        size="medium"
      />
    </div>
    <unlock-upsell
      v-if="!hasFilterAccess && !isFilterCard"
      title="Unlock onX Fish to use <strong>All Filters.</strong>"
      data-test="upsell"
      @upgrade="upgrade"
    />
    <filter-checkbox
      :filter-key="FILTER_KEYS[SLUGS.LAUNCH]"
      data-test="boat-launch"
      :include-all="false"
      :disabled="!hasFilterAccess"
      :origin="filterOrigin"
      class="content-item checkbox-group species"
      @change="handleCheckboxChange"
    />
  </div>
</template>
<script setup lang="ts">
///// imports /////
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import '@onxmaps/yellowstone-ui/ys-text'
import '@onxmaps/yellowstone-ui/ys-icon'
import '@onxmaps/yellowstone-ui/icons/ysLock'

import filterCheckbox from '@/components/filter-checkbox.vue'
import unlockUpsell from '@/components/shared/unlock-upsell.vue'

import { FishClaims } from '@/services/feature-access/fish/types'
import { useHasAccess } from '@/services/feature-access/composables'
import { FILTER_KEYS } from '@/services/filter-layer-service/constants'
import { SLUGS } from '@/fish/lib/taxonomy-constants'
import { applyMapFilteringDisplay } from '@/fish/lib/filtering/filter-map-display'
import { goToPurchase } from '@/lib/purchase-utils'
import {
  PURCHASE_CTA_ORIGINS,
  FILTER_ORIGINS,
  DISCOVER_ORIGINS,
} from '@/lib/enums-marketing'
import { HUMAN_SKUS } from '@/lib/plans'
import routeNames from '@/fish/router/constants'

///// refs and variables /////
const route = useRoute()
const { hasAccess: hasFilterAccess } = useHasAccess(
  FishClaims.waterbody_filters
)

///// computed /////
const isFilterCard = computed(
  () => route?.name === routeNames.WATERBODIES_FILTER
)

const filterOrigin = computed(() => {
  let origin = ''
  if (route.name === routeNames.WATERBODIES) {
    origin = FILTER_ORIGINS.DISCOVER
  } else if (route.name === routeNames.WATERBODIES_FILTER) {
    origin = DISCOVER_ORIGINS.MODE
  } else {
    origin = FILTER_ORIGINS.MAP
  }
  return origin
})
///// functions /////
const handleCheckboxChange = async () => {
  await applyMapFilteringDisplay()
}

const upgrade = () => {
  const sku = HUMAN_SKUS.FISH_ELITE_YEAR
  goToPurchase(
    {
      origin: isFilterCard.value
        ? PURCHASE_CTA_ORIGINS.FILTER_CARD
        : PURCHASE_CTA_ORIGINS.QUICK_FILTER,
      detail: 'Upgrade',
    },
    `product=${sku}&membership=elite`
  )
}
</script>
<style lang="scss" scoped>
.content-item {
  &.checkbox-group {
    padding: var(--ys-spacing-200) 0;
  }
  &.checkbox-group.species {
    :deep(.filter-options) {
      display: flex;
    }
  }
}

.filter {
  &:last-child {
    padding-bottom: var(--ys-spacing-250);
  }
  &__title {
    margin-bottom: var(--ys-spacing-50);
  }

  &__title-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
